"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAll = SelectAll;

var _reactAriaMenubutton = require("react-aria-menubutton");

var _dropdownMenu = require("./dropdown-menu");

var _media = require("react-components/media");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var caretIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M13.333 6l-2.72 2.877A3.744 3.744 0 018.28 10h-.484a3.737 3.737 0 01-2.332-1.123L2.667 6\"/></svg>";

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "select-all__Wrapper",
  componentId: "sc-pj954o-0"
})(["align-items:center;background-color:transparent;border-radius:", "px;display:grid;grid-column-gap:4px;grid-template-areas:'checkbox dropdown';grid-template-columns:repeat(2,max-content);height:36px;justify-content:center;transition:background-color ", ";white-space:nowrap;width:52px;", ""], (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('hasItemsSelected', (0, _styledComponents.css)(["background-color:", ";"], (0, _styles.color)('gray300'))));
/**
 * `Checkbox` styled component.
 */


var Checkbox = _styledComponents["default"].span.withConfig({
  displayName: "select-all__Checkbox",
  componentId: "sc-pj954o-1"
})(["cursor:pointer;grid-area:checkbox;height:24px;width:24px;"]);
/**
 * `StyledDropdownWrapper` styled component.
 */


var StyledDropdownWrapper = (0, _styledComponents["default"])(_reactAriaMenubutton.Wrapper).withConfig({
  displayName: "select-all__StyledDropdownWrapper",
  componentId: "sc-pj954o-2"
})(["grid-area:dropdown;height:24px;position:relative;"]);
/**
 * `StyledDropdownButton` styled component.
 */

var StyledDropdownButton = (0, _styledComponents["default"])(_reactAriaMenubutton.Button).withConfig({
  displayName: "select-all__StyledDropdownButton",
  componentId: "sc-pj954o-3"
})(["color:", ";cursor:pointer;outline-width:0;position:relative;transition:color ", ";&:focus-visible{outline-width:4px;}&:-moz-focusring{outline-width:1px;}&:focus,&:hover{color:", ";}"], (0, _styles.color)('gray500'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styles.color)('primary'));
/**
 * `Caret` styled component.
 */

var Caret = (0, _styledComponents["default"])(_media.Icon).attrs({
  'aria-hidden': true,
  icon: caretIcon
}).withConfig({
  displayName: "select-all__Caret",
  componentId: "sc-pj954o-4"
})(["top:4px;"]);
/**
 * `Path` styled component.
 */

var Path = _styledComponents["default"].path.withConfig({
  displayName: "select-all__Path",
  componentId: "sc-pj954o-5"
})(["fill:", ";stroke:", ";"], (0, _styledTools.prop)('fill', 'none'), (0, _styledTools.prop)('stroke', 'none'));
/**
 * `Rect` styled component.
 */


var Rect = _styledComponents["default"].rect.withConfig({
  displayName: "select-all__Rect",
  componentId: "sc-pj954o-6"
})(["fill:", ";stroke:", ";"], (0, _styledTools.prop)('fill', 'none'), (0, _styledTools.prop)('stroke', 'none'));
/**
 * Export `SelectAll` component.
 */


function SelectAll(props) {
  var _props$alignDropdown = props.alignDropdown,
      alignDropdown = _props$alignDropdown === void 0 ? 'left' : _props$alignDropdown,
      className = props.className,
      onSelect = props.onSelect,
      totalItems = props.totalItems,
      totalItemsSelected = props.totalItemsSelected;

  var _useTranslate = (0, _i18n.useTranslate)('common'),
      translate = _useTranslate.translate;

  var hasItems = totalItems > 0 && totalItemsSelected > 0;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValue = _useState2[0],
      setValue = _useState2[1];

  var handleClickDropdownMenuItem = (0, _react.useCallback)(function (value) {
    if (onSelect) {
      onSelect(value);
      setValue(value);
    }
  }, [onSelect]);
  var handleClickCheckbox = (0, _react.useCallback)(function () {
    var value = selectedValue === 'all' ? null : 'all';

    if (onSelect) {
      onSelect(value);
      setValue(value);
    }
  }, [onSelect, selectedValue]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: className,
    hasItemsSelected: hasItems
  }, /*#__PURE__*/_react["default"].createElement(Checkbox, {
    onClick: handleClickCheckbox
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg'
  }, /*#__PURE__*/_react["default"].createElement(Rect, {
    fill: totalItemsSelected > 0 ? (0, _styles.color)('primary') : 'none',
    height: '18',
    rx: '3',
    stroke: totalItemsSelected > 0 ? (0, _styles.color)('primary') : (0, _styles.color)('gray500'),
    strokeWidth: '2',
    width: '18',
    x: '3',
    y: '3'
  }), hasItems && totalItemsSelected < totalItems && /*#__PURE__*/_react["default"].createElement(Path, {
    d: 'M18.4947 11.9995H5.50415',
    stroke: (0, _styles.color)('white'),
    strokeMiterlimit: '10',
    strokeWidth: '2'
  }), hasItems && totalItemsSelected === totalItems && /*#__PURE__*/_react["default"].createElement(Path, {
    d: 'm17.6875 8.24194-5.388 6.61326c-.4207.5119-.9915.833-1.6069.9032H9.848c-.61546-.0702-1.18701-.3913-1.6069-.9032l-1.9286-2.3166',
    stroke: (0, _styles.color)('white'),
    strokeMiterlimit: '10',
    strokeWidth: '2'
  }))), /*#__PURE__*/_react["default"].createElement(StyledDropdownWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledDropdownButton, null, /*#__PURE__*/_react["default"].createElement(Caret, {
    size: '16px'
  })), /*#__PURE__*/_react["default"].createElement(_dropdownMenu.StyledMenu, {
    align: alignDropdown
  }, /*#__PURE__*/_react["default"].createElement(_dropdownMenu.DropdownMenuItem, {
    onClick: function onClick() {
      return handleClickDropdownMenuItem('all');
    }
  }, translate('common.selectAll')), /*#__PURE__*/_react["default"].createElement(_dropdownMenu.DropdownMenuItem, {
    onClick: function onClick() {
      return handleClickDropdownMenuItem(null);
    }
  }, translate('common.none')))));
}